var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueSignaturePad',{ref:"signaturePad",attrs:{"height":"300px","options":_vm.options}}),_c('div',{staticClass:"d-flex justify-space-between"},[_c('v-btn',{on:{"click":_vm.clear}},[_vm._v(_vm._s(_vm.$t('drSignaturePad.clear')))]),_c('v-btn',{on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('drSignaturePad.save')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }